import { Badge, Container, NavDropdown } from 'react-bootstrap';
import {
  Outlet,
  useLoaderData,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { Link } from 'react-router-dom';
import auth from '../common/services/AuthService';
import { useState } from 'react';
import { IUserFetchRes } from '../common/entities/IUser';
import { usePendingSubmissionsCount } from '../hooks/useSubmissions';

function Navigation() {
  const { user }: IUserFetchRes = useLoaderData() as IUserFetchRes;
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const { data: pendingCount } = usePendingSubmissionsCount();

  const logout = async () => {
    setIsLoading(true);
    try {
      await auth.logout();
      navigateToAuth();
    } catch (error) {
      navigateToAuth();
    }
  };

  const navigateToAuth = () => {
    navigate('/auth/signin');
  };

  const getFullName = () =>{
    const name: string = `${user.name.first} ${user.name.last}`;
    return name.length > 30 ? `${name.slice(0, 30)}...` : name;
  }

  return (
    <>
      <Navbar expand="lg" bg="primary">
        <Container fluid className="px-4">
          <Navbar.Brand as={Link} to="/">
            PlayRecLand
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="navbar-nav" />
          <Navbar.Collapse id="navbar-nav">
            <Nav activeKey={location.pathname} className="me-auto">
              <Nav.Link eventKey="/" as={Link} to="/">
                ด่าน
              </Nav.Link>
              <Nav.Link eventKey="/rewards" as={Link} to="/rewards">
                ของรางวัล
              </Nav.Link>
              <Nav.Link eventKey="/backgrounds" as={Link} to="/backgrounds">
                ฉากหลัง
              </Nav.Link>
              <Nav.Link eventKey="/learn-content" as={Link} to="/learn-content">
                องค์ความรู้
              </Nav.Link>
              <Nav.Link eventKey="/users" as={Link} to="/users">
                ผู้ใช้
              </Nav.Link>
              <Nav.Link eventKey="/submissions" as={Link} to="/submissions">
                ส่งงาน{' '}
                {pendingCount !== undefined && pendingCount > 0 && (
                  <Badge bg="danger" pill>{pendingCount}</Badge>
                )}
              </Nav.Link>
            </Nav>
            <NavDropdown
              className="lg:d-flex dropdown-nav"
              title={getFullName()}
              id="nav-dropdown"
            >
              <NavDropdown.Item onClick={() => {}}>
                ประวัติโดยย่อ
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item disabled={isLoading} onClick={logout}>
                ออกจากระบบ
              </NavDropdown.Item>
            </NavDropdown>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <Container fluid className="p-4">
        <Outlet />
      </Container>
    </>
  );
}

export default Navigation;
